module.exports = __webpack_public_path__ + "img/launch-fbm.557e54fc.svg";